import queryString from "query-string"

export const baseURL = import.meta.env.VITE_BASE_URL
export const baseFileURL = baseURL?.replace("/api", "")

export const Reference = {
  organizatoin: "/auth/api/v1/organizations/",
  role: "/auth/api/v1/roles/",
  region: "/settings/api/v1/soato-sources/?soato_type=region",
  district: "/settings/api/v1/soato-sources/?soato_type=district",
  coogu: "/settings/api/v1/economic-classifiers?classifier_type=coogu",
  oked: "/settings/api/v1/economic-classifiers?classifier_type=oked",
  companies: "/auth/api/v1/companies/",
  auditTypes: "/intensity/api/v1/energy-audit-types/"
} as const

export const PAGER = { page: 1, page_size: 30 } as const

export const paramsSerializer = (params: Record<string, any>) => {
  return queryString.stringify(params, { arrayFormat: "none" })
}
